import Login from './login/index.page';

export function Index() {
  return <Login />;
}

export default Index;
